export class UploadFile {
  public customer_area_id;
  public filesize;
  public file;
  public ext;
}
